import React from 'react'
import {createContext} from 'react'

const NoteContext = createContext()

export default NoteContext


// WEBPACK FOOTER //
// ./src/context/notes/noteContext.jsx